import React from 'react'
import { DonutChart } from './d3-charts/donut-chart'

class Donut extends React.Component {
  constructor (props) {
    super(props)
    this.resizeChart = this.resizeChart.bind(this)
    this.loadSampleData = this.loadSampleData.bind(this)
    this.loadRandomValue = this.loadRandomValue.bind(this)
    // getinitialState
    this.state = {
      initData: props.data
    }
  }

  loadSampleData () {
    const _this = this
    _this.donuttychart.update(_this.state.initData)
  }

  loadRandomValue () {
    const _this = this
    _this.donuttychart.randomValues()
  }

  componentDidMount () {
    this.resizeChart()
    window.addEventListener('resize', this.resizeChart)
  }

  componentWillUnmount () {
    window.removeEventListener('resize', this.resizeChart)
  }

  resizeChart () {
    const { indentifier } = this.props
    const _this = this

    let path = '../../assets/charts/'

    let settings = {
      el: 'chartDonut' + indentifier,
      margin: { top: 0, right: 0, bottom: 0, left: 0 },
      palette: 'green',
      hasIcons: false,
      path: path
    }
    _this.donuttychart = new DonutChart()

    // if any exist refresh them
    if (document.getElementsByClassName('donutChart').length > 0) {
      const wrapper = document.getElementsByClassName('donutChart')[0]
      wrapper.innerHTML = ''
    }

    _this.donuttychart
      .create(settings)
      .done()
      .then(function () {
        _this.donuttychart.update(_this.state.initData)
      })
  }

  render () {
    const { indentifier } = this.props

    const divStyle = {
      stroke: 'none',
      fill: '#e040fb'
    }

    const dotStyle = {
      fill: '#7455FF'
    }

    return (
      <div className="donut-chart chart-wrapper">
        <div id={'chartDonut' + indentifier} />
        <svg
          height="10"
          width="10"
          xmlns="http://www.w3.org/2000/svg"
          version="1.1"
        >
          <defs>
            <pattern
              id="circles-6"
              patternUnits="userSpaceOnUse"
              width="10"
              height="10"
            >
              <image
                xlinkHref="data:image/svg+xml;base64,PHN2ZyB4bWxucz0naHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmcnIHdpZHRoPScxMCcgaGVpZ2h0PScxMCc+CiAgPHJlY3Qgd2lkdGg9JzEwJyBoZWlnaHQ9JzEwJyBmaWxsPSd3aGl0ZScgLz4KICA8Y2lyY2xlIGN4PSczLjUnIGN5PSczLjUnIHI9JzMuNScgZmlsbD0nYmxhY2snLz4KPC9zdmc+Cg=="
                x="0"
                y="0"
                width="10"
                height="10"
              >
                {' '}
              </image>
            </pattern>
            <pattern
              id="pattern1"
              x="10"
              y="10"
              width="12"
              height="12"
              patternUnits="userSpaceOnUse"
            >
              <circle cx="6" cy="6" r="3" style={divStyle} />
            </pattern>
          </defs>
        </svg>
        <svg
          className="donut_pattern_svg"
          xmlns="http://www.w3.org/2000/svg"
          version="1.1"
        >
          <defs>
            <pattern
              id="purpDotPattern"
              x="5"
              y="5"
              width="10"
              height="10"
              patternUnits="userSpaceOnUse"
            >
              <circle cx="1.5" cy="1.5" r="1.5" style={dotStyle} />
            </pattern>
          </defs>
        </svg>
      </div>
    )
  }
}

export default Donut
